<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="margin-right-small">
      <input matInput autocomplete="off" formControlName="DateFrom" [matDatepicker]="pickerFrom" placeholder="Fecha desde" required>
      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
      <mat-error *ngIf="f.DateFrom.errors && f.DateFrom.errors.required">
          Ingrese la fecha desde
      </mat-error>
  </mat-form-field>
  <mat-form-field class="margin-right-small">
      <input matInput autocomplete="off" formControlName="DateTo" [matDatepicker]="pickerTo" placeholder="Fecha hasta" required>
      <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerTo></mat-datepicker>
      <mat-error *ngIf="f.DateTo.errors && f.DateTo.errors.required">
          Ingrese la fecha hasta
      </mat-error>
  </mat-form-field>

  <mat-form-field class="full-width">
      <mat-select placeholder="Centros" formControlName="Centers" multiple>
          <mat-select-trigger>
              {{f.Centers.value?.length > 0 ? f.Centers.value[0].Name : ''}}
              <span *ngIf="f.Centers.value?.length > 1" class="additional-selection">
          (+{{f.Centers.value.length - 1}} {{f.Centers.value?.length === 2 ? 'otro' : 'otros'}})
        </span>
          </mat-select-trigger>
          <mat-option *ngFor="let centerFilter of centerFilters" [value]="centerFilter">
              {{centerFilter.Name}}
          </mat-option>
      </mat-select>
  </mat-form-field>

  <mat-form-field class="full-width">
      <mat-select placeholder="Servicios" formControlName="Services" multiple>
          <mat-select-trigger>
              {{f.Services.value?.length > 0 ? f.Services.value[0].Name : ''}}
              <span *ngIf="f.Services.value?.length > 1" class="additional-selection">
        (+{{f.Services.value.length - 1}} {{f.Services.value?.length === 2 ? 'otro' : 'otros'}})
      </span>
          </mat-select-trigger>
          <mat-option *ngFor="let serviceFilter of serviceFilters" [value]="serviceFilter">
              {{serviceFilter.Name}}
          </mat-option>
      </mat-select>
  </mat-form-field>

  <div class="full-width">
      <patient-autocomplete formControlName="Patient"></patient-autocomplete>
  </div>
  <mat-checkbox class="margin-right-small" formControlName="ViewCancel">Ver cancelados</mat-checkbox>
  <mat-checkbox class="margin-right-small" formControlName="ReAppointmentPendient">Ver recitados pendientes</mat-checkbox>
  <mat-checkbox class="margin-right-small" formControlName="ReAppointment">Ver recitados agendados</mat-checkbox>
</form>
